import { render, staticRenderFns } from "./StatusDuration.vue?vue&type=template&id=b1241534&"
import script from "./StatusDuration.vue?vue&type=script&lang=js&"
export * from "./StatusDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports